export const environment = {
  production: true,
  buildId: '3033475864319991',
  configFile: 'config.json',
};
